/** Bootstrap cache is scoped per auth token so login/logout/impersonate never reuse stale session data. */
export const queryKeys = {
  app: (token?: string | null) => ['app', token ?? ''] as const,
  orderActivity: (orderId: string) => ['orderActivity', orderId] as const,
};
